import "swiper/css";
import Swiper from "swiper";

const button_load_more = document.querySelector("#btn-load-more-posts")

if (button_load_more) {
  button_load_more.addEventListener('click', () => {
    console.log('Load more posts...')

    const data = new FormData()
    data.append('action', 'load_more_posts')
    data.append('nonce', blog_data.load_more_posts_nonce)
    data.append('offset', button_load_more.dataset.offset)
    data.append('start', button_load_more.dataset.offset)
    data.append('category', button_load_more.dataset.category)

    fetch(blog_data.ajax_url, {
      method: "POST",
      credentials: 'same-origin',
      body: data
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data)

        const grid_element = document.querySelector('.section-latest-posts-items')
        if (grid_element) {
          grid_element.insertAdjacentHTML("beforeend", data.content);
        }

        // Update offset
        button_load_more.dataset.offset = data.offset

        // Hide load more on the last page
        if (data.max_pages === data.offset) {
          button_load_more.classList.add('d-none')
        }
      })
      .catch((error) => {
        console.error('Load more error:', error)
      })
  })
}

const filter_items = document.querySelectorAll('.category-filter-item')
const grid_element = document.querySelector('.section-latest-posts-items')
const pagination_wrap = document.querySelector('.blog-pagination')

// ── Core fetch ────────────────────────────────────────────────
function fetchPosts(category, page) {
  const data = new FormData()
  data.append('action', 'filter_posts_by_category')
  data.append('nonce', blog_data.filter_posts_nonce)
  data.append('category', category)
  data.append('page', page)

  return fetch(blog_data.ajax_url, {
    method: 'POST',
    credentials: 'same-origin',
    body: data
  }).then((res) => res.json())
}

// ── Render posts + pagination ─────────────────────────────────
function renderResults(data) {
  if (grid_element) {
    grid_element.innerHTML = ''
    grid_element.insertAdjacentHTML('beforeend', data.content)
  }

  if (pagination_wrap) {
    pagination_wrap.innerHTML = data.pagination || ''
    bindPagination() // rebind after re-render
  }

  // Scroll back to top of grid smoothly
  grid_element?.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

// ── URL / history helpers ─────────────────────────────────────
function buildUrl(category, page) {
  const url = new URL(window.location.href)
  url.search = ''
  // Strip any existing /page/N/ and rebuild from the blog base path
  const base = url.pathname.replace(/\/page\/\d+\/?$/, '').replace(/\/?$/, '/')
  url.pathname = Number(page) > 1 ? `${base}page/${Number(page)}/` : base
  if (category) url.searchParams.set('category', category)
  return url.href
}

function currentCategory() {
  return document.querySelector('.category-filter-item.active')?.dataset.category || ''
}

function setActiveCategory(category) {
  filter_items.forEach((el) => {
    el.classList.toggle('active', String(el.dataset.category) === String(category))
  })
}

// Load a view; push to history unless triggered by Back/Forward
function loadView(category, page, push = true) {
  return fetchPosts(category, page)
    .then((data) => {
      renderResults(data)
      if (push) {
        history.pushState({ category, page: Number(page) }, '', buildUrl(category, page))
      }
    })
    .catch((err) => console.error('Posts load error:', err))
}

// ── Pagination link clicks ────────────────────────────────────
function bindPagination() {
  pagination_wrap?.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault()

      // paginate_links uses ?paged=N or /page/N — extract from href
      const url = new URL(link.href)
      const paged = url.searchParams.get('paged')
        || link.href.match(/\/page\/(\d+)/)?.[1]
        || 1

      loadView(currentCategory(), paged)
    })
  })
}

// ── Category filter clicks ────────────────────────────────────
if (filter_items.length) {
  filter_items.forEach((item) => {
    item.addEventListener('click', () => {
      if (item.classList.contains('active')) return

      setActiveCategory(item.dataset.category)
      loadView(item.dataset.category, 1) // reset to page 1 on filter change
    })
  })
}

// ── Back / Forward ────────────────────────────────────────────
if (grid_element) {
  const initialUrl = new URL(window.location.href)
  history.replaceState(
    {
      category: initialUrl.searchParams.get('category') || '',
      page: Number(initialUrl.pathname.match(/\/page\/(\d+)/)?.[1] || 1)
    },
    '',
    window.location.href
  )

  window.addEventListener('popstate', (e) => {
    const state = e.state
    if (!state) return
    setActiveCategory(state.category || '')
    loadView(state.category || '', state.page || 1, false)
  })
}

// ── Bind on initial page load ─────────────────────────────────
bindPagination()

const mobileNavQuery = window.matchMedia("(max-width: 1200px)")

if (mobileNavQuery.matches) {
  const filter_section_title = document.querySelector(".categories-filter-section-title")

  if (filter_section_title) {
    filter_section_title.addEventListener('click', (e) => {
      const filter_section_list = document.querySelector(".categories-filter-section-list")

      if (!filter_section_list) return;

      e.currentTarget.classList.toggle('active')

      if (filter_section_list.style.opacity === '1') {
        filter_section_list.style.visibility = 'hidden';
        filter_section_list.style.opacity = 0;
        filter_section_list.style.maxHeight = '0';
        filter_section_list.style.padding = '0';
      } else {
        filter_section_list.style.visibility = 'visible';
        filter_section_list.style.opacity = 1;
        filter_section_list.style.maxHeight = '200px';
        filter_section_list.style.padding = '12px';
      }
    })
  }
}

const logoStrips = document.querySelectorAll(".logo-strip-swiper");
logoStrips.forEach((slider, index) => {
  slider.classList.add(`logo-strip-swiper-${index}`);

  new Swiper(`.logo-strip-swiper-${index}`, {
    slidesPerView: 3.5,
    spaceBetween: 16,
    loop: true,
    speed: 500,
    breakpoints: {
      576: { slidesPerView: 5, spaceBetween: 16 },
      768: { slidesPerView: 7, spaceBetween: 20 },
      992: { slidesPerView: 8, spaceBetween: 24 },
      1200: { slidesPerView: 10, spaceBetween: 24 },
    },
  });
});